var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo.isSystemAdministrator
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-new": false,
              "show-print": false,
              "show-delete": false,
              "show-save": false,
              "show-lock": false,
              "show-cancel": _vm.showCancel,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [_c("system-modules-side-menu")],
              1
            ),
            _c(
              "div",
              { staticClass: "column" },
              [_c("router-view", { ref: "currentChild" })],
              1
            ),
          ]),
        ],
        1
      )
    : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
        _c(
          "div",
          {
            staticClass:
              "notification is-danger is-flex is-justify-content-center is-size-4",
            staticStyle: { width: "50%" },
          },
          [_vm._v("You do not have permissions on this page")]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }